import { PaginationDto } from '@marketplace-web/domain/pagination-data'

import usePagination, { FetcherArgs, Fetcher } from './usePagination'

type CommonData<T> = {
  items: Array<T>
  pagination: PaginationDto
}

type CommonItem<T> = {
  id: T
}

export default function usePaginationCommon<
  ItemId,
  Item extends CommonItem<ItemId>,
  Data extends CommonData<Item>,
  FArgs extends FetcherArgs,
>(fetcher: Fetcher<Data, FArgs>) {
  return usePagination({
    fetcher,
    getIsEndReached: ({ pagination }) => pagination.current_page >= pagination.total_pages,
    deduplicationUtils: {
      getItems: res => res.items,
      getItemId: item => item.id,
      replaceItems: (res, items) => ({ ...res, items }),
    },
  })
}
